export const baseURL = ['dev', 'dev-https'].includes(process.env.REACT_APP_NODE_ENV as string)
  ? process.env.REACT_APP_LOCAL_API_URL
  : process.env.REACT_APP_PRODUCTION_API_URL

export const Role = {
  admin: 1,
  developer: 2,
  employee: 3
}
